import {
	Button,
	Grid,
	MenuItem,
	Typography,
	makeStyles,
} from "@material-ui/core";
import React from "react";
import { useForm } from "react-hook-form";
import { ReactHookFormSelect } from "../../../utils";

const useStyles = makeStyles((theme) => ({
	optionDiv: {
		gap: theme.spacing(1),
		backgroundColor: "white",
		padding: theme.spacing(1),
		marginBottom: theme.spacing(3),
		boxShadow: "0px 2px 2px rgba(0, 0, 0, 0.25)",
		borderRadius: "5px 5px 5px 5px",
		[theme.breakpoints.down("xs")]: {
			gap: 0,
		},
	},
	button: {
		height: "3.3rem",
		width: "6rem",
		[theme.breakpoints.down("xs")]: {
			width: "100%",
			marginBottom: theme.spacing(4),
		},
	},
}));
export const OptionHandle = ({
	stateOption,
	handleSearch,
	state,
	setState,
	// option,
	// optionGroup,
	// handleOption,
}) => {
	const { handleSubmit, errors, control } = useForm();
	const classes = useStyles();

	return (
		<Grid container alignItems="center" className={classes.optionDiv}>
			<Grid item xs={12} sm={2} md={2}>
				<ReactHookFormSelect
					id="idlayanan"
					name="idlayanan"
					label="ID Layanan"
					control={control}
					error={errors.idlayanan}
					value={state.idlayanan}
					// handleOption={handleOption}
					rules={{
						required: {
							value: true,
							message: `ID layanan tidak boleh kosong`,
						},
					}}
					setState={setState}
					state={state}
					variant="outlined"
					margin="normal"
					fullWidth
					isService
					isForm
				>
					<MenuItem value="none" disabled selected>
						--Pilih Layanan--
					</MenuItem>
					<MenuItem value="0" selected>
						All
					</MenuItem>
					{stateOption.option1 &&
						stateOption.option1.map((item, i) => (
							<MenuItem key={i} value={item.id}>
								{item.nama}
							</MenuItem>
						))}
				</ReactHookFormSelect>
				{errors.idlayanan && (
					<Typography variant="caption" color="error">
						{errors.idlayanan.message}
					</Typography>
				)}
			</Grid>
			<Grid item xs={12} sm={2} md={2}>
				<ReactHookFormSelect
					id="idgroup"
					name="idgroup"
					label="ID Group"
					control={control}
					error={errors.idgroup}
					value={state.idgroup}
					// handleOption={handleOption}
					rules={{
						required: {
							value: true,
							message: `ID Group tidak boleh kosong`,
						},
					}}
					setState={setState}
					state={state}
					variant="outlined"
					margin="normal"
					fullWidth
				>
					<MenuItem value="none" disabled selected>
						--Pilih Group--
					</MenuItem>
					<MenuItem value="0" selected>
						All
					</MenuItem>
					{stateOption.option2 &&
						stateOption.option2.map((item, i) => (
							<MenuItem key={i} value={item.id}>
								{item.nama}
							</MenuItem>
						))}
				</ReactHookFormSelect>
				{errors.idgroup && (
					<Typography variant="caption" color="error">
						{errors.idgroup.message}
					</Typography>
				)}
			</Grid>
			<Grid item xs={12} sm={2} md={2}>
				<Button
					className={classes.button}
					variant="contained"
					color="primary"
					onClick={handleSubmit(handleSearch)}
				>
					Search
				</Button>
			</Grid>
		</Grid>
	);
};

export default OptionHandle;
